/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as paymethodV1 from "./keyapis_invoice_paymethod_v1.pb"

/**
 * Сервис реализует функционал управления выставленными счётами
 */

/**
 * Сервис invoices
 */
export class InvoiceServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод создания платежа.
   * Создание платежа в своей и внешней платежной системе.
   * Метод доступен для: service
   */
  CreateInvoice = (req: CreateInvoiceRequestDto, init?: RequestInit): Promise<CreateInvoiceResponseDto> => {
    return fm.request<CreateInvoiceRequestDto, CreateInvoiceResponseDto>(`${this.host}/invoice/api/v1/invoice`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения платежа.
   * Для master доступно получение платежа только с user_id из токена.
   * Метод доступен для: admin, service, master
   */
  GetInvoice = (req: GetInvoiceRequestDto, init?: RequestInit): Promise<GetInvoiceResponseDto> => {
    return fm.request<GetInvoiceRequestDto, GetInvoiceResponseDto>(`${this.host}/invoice/api/v1/invoice/${encodeURIComponent(req.invoiceId)}${fm.buildQuery(req, ["invoiceId"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод подтверждения платежа (вызывается со стороны внешней системы).
   * Не требует авторизации
   */
  PostInvoiceConfirm = (req: PostInvoiceConfirmRequestDto, init?: RequestInit): Promise<PostInvoiceConfirmResponseDto> => {
    return fm.request<PostInvoiceConfirmRequestDto, PostInvoiceConfirmResponseDto>(`${this.host}/invoice/internal/api/v1/invoice/confirm`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка платежей.
   * Для master доступно получение только собственных платежей, если параметр filter.user_id передан и не совпадает с user_id из токена, возвращается ошибка доступа.
   * Метод доступен для: admin, service, master, ltp_first
   */
  GetInvoiceList = (req?: GetInvoiceListRequestDto, init?: RequestInit): Promise<GetInvoiceListResponseDto> => {
    return fm.request<GetInvoiceListRequestDto, GetInvoiceListResponseDto>(`${this.host}/invoice/api/v1/invoice/list${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения количества платежей.
   * Для master в параметр filter.user_id подставляется user_id из токена.
   * Метод доступен для: admin, service, master, ltp_first
   */
  GetInvoiceCount = (req: GetInvoiceCountRequestDto, init?: RequestInit): Promise<GetInvoiceCountResponseDto> => {
    return fm.request<GetInvoiceCountRequestDto, GetInvoiceCountResponseDto>(`${this.host}/invoice/api/v1/invoice/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник банковских карт
 */
export enum InvoiceCardType {
  /**
   * Значение не указано
   */
  CARD_TYPE_UNKNOWN = "CARD_TYPE_UNKNOWN",
  /**
   * Карта VISA
   */
  VISA = "VISA",
  /**
   * Карта EuroCard/MasterCard
   */
  EC_MC = "EC_MC",
  /**
   * Карта DinersClub
   */
  DCL = "DCL",
  /**
   * Карта JCB
   */
  JCB = "JCB",
  /**
   * Карта American Express
   */
  AMEX = "AMEX",
  /**
   * Платежная система \"Мир\"
   */
  MIR = "MIR",
}
/**
 * Справочник банковских карт
 */
export type InvoiceCardTypeResponseEnum = keyof typeof InvoiceCardType
/**
 * Справочник банковских карт
 */
export type InvoiceCardTypeRequestEnum = Exclude<InvoiceCardTypeResponseEnum, "CARD_TYPE_UNKNOWN">;

/**
 * Справочник типов статусов оплаты счёта
 */
export enum InvoiceInvoiceStatusType {
  /**
   * Значение не указано
   */
  INVOICE_STATUS_TYPE_UNKNOWN = "INVOICE_STATUS_TYPE_UNKNOWN",
  /**
   * Создан, ожидает подтверждения
   */
  PLANNED = "PLANNED",
  /**
   * Ожидает оплаты
   */
  PENDING = "PENDING",
  /**
   * Ошибка оплаты
   */
  ERROR = "ERROR",
  /**
   * Оплачен
   */
  PAID = "PAID",
  /**
   * Отменен
   */
  CANCELLED = "CANCELLED",
}
/**
 * Справочник типов статусов оплаты счёта
 */
export type InvoiceInvoiceStatusTypeResponseEnum = keyof typeof InvoiceInvoiceStatusType
/**
 * Справочник типов статусов оплаты счёта
 */
export type InvoiceInvoiceStatusTypeRequestEnum = Exclude<InvoiceInvoiceStatusTypeResponseEnum, "INVOICE_STATUS_TYPE_UNKNOWN">;

/**
 * Справочник методов платежа
 */
export enum InvoicePayInterfaceType {
  /**
   * Значение не указано
   */
  PAY_INTERFACE_TYPE_UNKNOWN = "PAY_INTERFACE_TYPE_UNKNOWN",
  /**
   * Оплата через интерфейс предпроцессинга
   */
  GUI = "GUI",
  /**
   * Оплата с использованием ранее созданного способа платежа, настроенного по умолчанию
   */
  M2M = "M2M",
}
/**
 * Справочник методов платежа
 */
export type InvoicePayInterfaceTypeResponseEnum = keyof typeof InvoicePayInterfaceType
/**
 * Справочник методов платежа
 */
export type InvoicePayInterfaceTypeRequestEnum = Exclude<InvoicePayInterfaceTypeResponseEnum, "PAY_INTERFACE_TYPE_UNKNOWN">;

/**
 * Справочник типов платежных средств
 */
export enum InvoicePaywayType {
  /**
   * Значение не указано
   */
  PAYWAY_TYPE_UNKNOWN = "PAYWAY_TYPE_UNKNOWN",
  /**
   * Банковская карта
   */
  BANK_CARD = "BANK_CARD",
  /**
   * Сервис быстрых платежей
   */
  SBP = "SBP",
  /**
   * Связка Сбербанка
   */
  SBER_PAY = "SBER_PAY",
}
/**
 * Справочник типов платежных средств
 */
export type InvoicePaywayTypeResponseEnum = keyof typeof InvoicePaywayType
/**
 * Справочник типов платежных средств
 */
export type InvoicePaywayTypeRequestEnum = Exclude<InvoicePaywayTypeResponseEnum, "PAYWAY_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки.
 */
export enum InvoicePagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type InvoicePagingDirectionTypeResponseEnum = keyof typeof InvoicePagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type InvoicePagingDirectionTypeRequestEnum = Exclude<InvoicePagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum InvoicePagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * По дате оплаты
   */
  PAID_AT = "PAID_AT",
  /**
   * По дате создания
   */
  CREATED_AT = "CREATED_AT",
}
/**
 * Справочник типов значений сортировки.
 */
export type InvoicePagingOrderByTypeResponseEnum = keyof typeof InvoicePagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type InvoicePagingOrderByTypeRequestEnum = Exclude<InvoicePagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос на создание платежа
 */
export type CreateInvoiceRequestDto = {
  /**
   * Идентификатор пользователя
   */
  userId: number
  /**
   * Позиция счета
   */
  positions: InvoicePositionRequestDto[]
  /**
   * Метод платежа
   */
  payInterfaceType: InvoicePayInterfaceTypeRequestEnum
  /**
   * Способ оплаты.
   * По умолчанию: BANK_CARD
   */
  paywayType?: InvoicePaywayTypeRequestEnum | "PAYWAY_TYPE_UNKNOWN"
  /**
   * Ссылка для перехода после оплаты.
   * Если не передан подставится значение по умолчанию
   */
  returnUrl?: string
  /**
   * Номер телефона.
   * Должно быть означено поле phone_number, либо поле email
   */
  phoneNumber?: string
  /**
   * Электронная почта.
   * Должно быть означено поле phone_number, либо поле email
   */
  email?: string
  /**
   * Описание платежа.
   * По умолчанию подставляется \"Счёт от {DD.MM.YYYY}г.\"
   */
  title?: string
}
/**
 * Ответ на запрос создание платежа
 */
export type CreateInvoiceResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly error: CreateInvoiceResponseErrorDto
  /**
   * Платеж
   */
  readonly data: InvoiceResponseDto
}>
/**
 * Ошибка запроса
 */
export type CreateInvoiceResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: paymethodV1.ValidationErrorRequestDto
  /**
   * Должно быть означено поле phone_number, либо поле email
   */
  readonly missingUserContacts: CreateInvoiceResponseErrorMissingUserContactsRequestDto
  /**
   * Ошибки внешней системы
   */
  readonly external: InvoiceExternalErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: InvoiceSavingErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type CreateInvoiceResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: paymethodV1.ValidationErrorResponseDto
  /**
   * Должно быть означено поле phone_number, либо поле email
   */
  readonly missingUserContacts: CreateInvoiceResponseErrorMissingUserContactsDto
  /**
   * Ошибки внешней системы
   */
  readonly external: InvoiceExternalErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: InvoiceSavingErrorResponseDto
}>
/**
 * Должно быть означено поле phone_number, либо поле email
 */
export type CreateInvoiceResponseErrorMissingUserContactsRequestDto = {
}
/**
 * Должно быть означено поле phone_number, либо поле email
 */
export type CreateInvoiceResponseErrorMissingUserContactsDto = {
}
/**
 * Запрос на получение количества платежей
 */
export type GetInvoiceCountRequestDto = {
  /**
   * Фильтр
   */
  filter: InvoiceFilterRequestDto
}
/**
 * Ответ на запрос получения количества платежей
 */
export type GetInvoiceCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Количество
   */
  readonly data: number
}>
/**
 * Запрос на получение списка платежей
 */
export type GetInvoiceListRequestDto = {
  /**
   * Фильтр
   */
  filter?: InvoiceFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: InvoicePagingRequestDto
}>
/**
 * Ответ на запрос получения списка платежей
 */
export type GetInvoiceListResponseDto = {
  /**
   * Платежи
   */
  data: InvoiceResponseDto[]
  /**
   * Ошибка
   */
  error: GetInvoiceListResponseErrorDto | null
}
/**
 * Ошибка запроса на получение списка платежей
 */
export type GetInvoiceListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: paymethodV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса на получение списка платежей
 */
export type GetInvoiceListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: paymethodV1.ValidationErrorResponseDto
}>
/**
 * Запрос на получение статуса платежа
 */
export type GetInvoiceRequestDto = {
  /**
   * Идентификатор платежа в Ключе.
   * # Тип: Guid
   */
  invoiceId: string
}
/**
 * Ответ на запрос получения платежа
 */
export type GetInvoiceResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: GetInvoiceResponseErrorDto
  /**
   * Платеж
   */
  readonly data: InvoiceResponseDto
}>
/**
 * Ошибка запроса
 */
export type GetInvoiceResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: paymethodV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type GetInvoiceResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: paymethodV1.ValidationErrorResponseDto
}>
/**
 * Выставленный счёт
 */
export type InvoiceRequestDto = {
  /**
   * Идентификатор платежа.
   * # Тип: Guid
   */
  id: string
  /**
   * Описание платежа
   */
  title: string
  /**
   * Идентификатор пользователя
   */
  userId: number
  /**
   * Статус платежа
   */
  invoiceStatusType: InvoiceInvoiceStatusTypeRequestEnum
  /**
   * Дата создания платежа.
   * # Тип: DateTime
   */
  createdAt: string
  /**
   * Дата обновления платежа.
   * # Тип: DateTime
   */
  updatedAt: string
  /**
   * Позиция счета
   */
  positions: InvoicePositionRequestDto[]
  /**
   * Метод платежа
   */
  payInterfaceType?: InvoicePayInterfaceTypeRequestEnum | "PAY_INTERFACE_TYPE_UNKNOWN"
  /**
   * Способ оплаты
   */
  paywayType?: InvoicePaywayTypeRequestEnum | "PAYWAY_TYPE_UNKNOWN"
  /**
   * Дата изменения статуса платежа.
   * # Тип: DateTime
   */
  statusChangedAt?: string | null
  /**
   * Дата платежа.
   * # Тип: DateTime
   */
  paidAt?: string | null
  /**
   * Платежная ссылка
   */
  payUrl?: string
  /**
   * Маскированный номер карты при платеже
   */
  paidByCardMasked?: string
  /**
   * Идентификатор платежного средства в внешней системы
   */
  paidByCardEsppId?: string
  /**
   * Тип банковской карты
   */
  cardType?: InvoiceCardTypeRequestEnum | "CARD_TYPE_UNKNOWN"
  /**
   * Код ошибки внешней системы
   */
  esppReqStatus?: number
  /**
   * Комментарий к статусу платежа из внешней системы
   */
  esppReqUserMsg?: string
  /**
   * Уникальный номер транзакции в внешней системы
   */
  esppInvoiceId?: string
  /**
   * Номер телефона
   */
  phoneNumber?: string
  /**
   * Электронная почта
   */
  email?: string
}
/**
 * Выставленный счёт
 */
export type InvoiceResponseDto = {
  /**
   * Идентификатор платежа.
   * # Тип: Guid
   */
  id: string
  /**
   * Описание платежа
   */
  title: string
  /**
   * Идентификатор пользователя
   */
  userId: number
  /**
   * Статус платежа
   */
  invoiceStatusType: InvoiceInvoiceStatusTypeResponseEnum
  /**
   * Дата создания платежа.
   * # Тип: DateTime
   */
  createdAt: string
  /**
   * Дата обновления платежа.
   * # Тип: DateTime
   */
  updatedAt: string
  /**
   * Позиция счета
   */
  positions: InvoicePositionResponseDto[]
  /**
   * Метод платежа
   */
  payInterfaceType: InvoicePayInterfaceTypeResponseEnum
  /**
   * Способ оплаты
   */
  paywayType: InvoicePaywayTypeResponseEnum
  /**
   * Дата изменения статуса платежа.
   * # Тип: DateTime
   */
  statusChangedAt: string | null
  /**
   * Дата платежа.
   * # Тип: DateTime
   */
  paidAt: string | null
  /**
   * Платежная ссылка
   */
  payUrl: string
  /**
   * Маскированный номер карты при платеже
   */
  paidByCardMasked: string
  /**
   * Идентификатор платежного средства в внешней системы
   */
  paidByCardEsppId: string
  /**
   * Тип банковской карты
   */
  cardType: InvoiceCardTypeResponseEnum
  /**
   * Код ошибки внешней системы
   */
  esppReqStatus: number
  /**
   * Комментарий к статусу платежа из внешней системы
   */
  esppReqUserMsg: string
  /**
   * Уникальный номер транзакции в внешней системы
   */
  esppInvoiceId: string
  /**
   * Номер телефона
   */
  phoneNumber: string
  /**
   * Электронная почта
   */
  email: string
}
/**
 * Ошибки внешней системы
 */
export type InvoiceExternalErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Запрос к внешней системе вернул ошибку или прекращен по таймауту
   */
  readonly externalSystemError: InvoiceExternalErrorExternalSystemErrorRequestDto
}>
/**
 * Ошибки внешней системы
 */
export type InvoiceExternalErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Запрос к внешней системе вернул ошибку или прекращен по таймауту
   */
  readonly externalSystemError: InvoiceExternalErrorExternalSystemErrorResponseDto
}>
/**
 * Запрос к внешней системе вернул ошибку или прекращен по таймауту
 */
export type InvoiceExternalErrorExternalSystemErrorRequestDto = {
}
/**
 * Запрос к внешней системе вернул ошибку или прекращен по таймауту
 */
export type InvoiceExternalErrorExternalSystemErrorResponseDto = {
}
/**
 * Позиция счета
 */
export type InvoicePositionRequestDto = {
  /**
   * Идентификатор позиции.
   * # Тип: Guid
   */
  id?: string
  /**
   * Идентификатор платежа.
   * # Тип: Guid
   */
  invoiceId: string
  /**
   * Название позиции
   */
  title: string
  /**
   * Категория позиции (='subscription')
   */
  category: string
  /**
   * Цена в рублях.
   * Число должно быть больше 0
   */
  amount: number
  /**
   * Идентификатор МРФ
   */
  mrfId: number
  /**
   * Идентификатор РФ
   */
  rfId: number
  /**
   * Идентификатор экземпляра оплачиваемой подписки.
   * # Тип: Guid
   */
  instanceId: string
  /**
   * Идентификатор предложения оплачиваемой подписки
   */
  offeringId: number
  /**
   * Срок окончания оплачиваемого периода
   */
  dueDateAt?: string | null
  /**
   * Идентификатор получателя платежа
   */
  svcTypeId?: string
  /**
   * Признак скидки
   */
  isDiscount?: boolean
}
/**
 * Позиция счета
 */
export type InvoicePositionResponseDto = {
  /**
   * Идентификатор позиции.
   * # Тип: Guid
   */
  id: string
  /**
   * Идентификатор платежа.
   * # Тип: Guid
   */
  invoiceId: string
  /**
   * Название позиции
   */
  title: string
  /**
   * Категория позиции (='subscription')
   */
  category: string
  /**
   * Цена в рублях.
   * Число должно быть больше 0
   */
  amount: number
  /**
   * Дата создания позиции платежа.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Дата обновления позиции платежа.
   * # Тип: DateTime
   */
  readonly updatedAt: string | null
  /**
   * Идентификатор МРФ
   */
  mrfId: number
  /**
   * Идентификатор РФ
   */
  rfId: number
  /**
   * Идентификатор экземпляра оплачиваемой подписки.
   * # Тип: Guid
   */
  instanceId: string
  /**
   * Идентификатор предложения оплачиваемой подписки
   */
  offeringId: number
  /**
   * Срок окончания оплачиваемого периода
   */
  dueDateAt: string | null
  /**
   * Идентификатор получателя платежа
   */
  svcTypeId: string
  /**
   * Признак скидки
   */
  isDiscount: boolean
}
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type InvoiceSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * У пользователя уже есть платеж со статусом PENDING
   */
  readonly invoiceAlreadyExists: InvoiceSavingErrorInvoiceAlreadyExistsRequestDto
}>
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type InvoiceSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * У пользователя уже есть платеж со статусом PENDING
   */
  readonly invoiceAlreadyExists: InvoiceSavingErrorInvoiceAlreadyExistsResponseDto
}>
/**
 * У пользователя уже есть платеж со статусом PENDING
 */
export type InvoiceSavingErrorInvoiceAlreadyExistsRequestDto = {
}
/**
 * У пользователя уже есть платеж со статусом PENDING
 */
export type InvoiceSavingErrorInvoiceAlreadyExistsResponseDto = {
}
/**
 * Фильтр инвойсов
 */
export type InvoiceFilterRequestDto = {
  /**
   * Идентификатор пользователя
   */
  userId?: number
  /**
   * Статус платежа
   */
  invoiceStatusType?: InvoiceInvoiceStatusTypeResponseEnum
}
/**
 * Фильтр инвойсов
 */
export type InvoiceFilterResponseDto = {
  /**
   * Идентификатор пользователя
   */
  userId: number
  /**
   * Статус платежа
   */
  invoiceStatusType: InvoiceInvoiceStatusTypeResponseEnum
}
/**
 * Постраничный вывод
 */
export type InvoicePagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: PAID_AT
   */
  orderByType?: InvoicePagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: InvoicePagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type InvoicePagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: PAID_AT
   */
  orderByType: InvoicePagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: InvoicePagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Запрос на подтверждение платежа
 */
export type PostInvoiceConfirmRequestDto = {
  /**
   * Идентификатор платежа в Ключе
   */
  srcPayId: string
  /**
   * Идентификатор платежа во внешней системе
   */
  esppPayId: string
  /**
   * Статус платежа из внешней системы
   */
  payStatus: number
  /**
   * Тип запроса.
   * Должно иметь значение \"confirmPayment\"
   */
  reqType: string
  /**
   * Сумма платежа в минимальных единицах валюты
   */
  amount?: number
  /**
   * Код валюты платежа
   */
  currency?: string
  /**
   * Код способа оплаты
   */
  payMethod?: string
  /**
   * Дата регистрации платежа.
   * # Тип: DateTime
   */
  createTimeAt?: string | null
  /**
   * Комментарий или сообщение об ошибке
   */
  reqNote?: string
  /**
   * Сообщение, отображаемое пользователю
   */
  reqUserMsg?: string
  /**
   * Время фактической оплаты. Время фактической оплаты на стороне Процессинга. Возвращается, если оплата состоялась
   */
  payTimeAt?: string | null
  /**
   * Время фактической отмены оплаты.
   * Время фактической отмены оплаты на стороне Процессинга.
   * Возвращается, если отмена оплаты состоялась
   */
  abandonTimeAt?: string | null
  /**
   * Структура с информацией о карте плательщика.
   * Передаётся только при успешном платеже и если указаны способы оплаты payMethod = StoredBankCard либо BankCard
   */
  card?: PostInvoiceConfirmRequestCardDto | null
}
/**
 * Структура с информацией о карте плательщика
 */
export type PostInvoiceConfirmRequestCardDto = {
  /**
   * Идентификатор платежного средства во внешней системы.
   * Возвращается в случае успешной привязки БК к УЗ
   */
  esppCardId?: number
  /**
   * Номер платежного средства.
   * Маскированный номер карты. Например: 123456******7890
   */
  cardNum?: string
  /**
   * Тип банковской карты
   */
  cardKind?: string
  /**
   * Банк-эмитент.
   * Наименование банка-эмитента. Процессинг может вернуть значение \"НЕ ЗАДАВАЛСЯ\".
   * В этом случае рекомендуется не отображать эту информацию для пользователя
   */
  bankName?: string
}
/**
 * Ответ на запрос подтверждения платежа
 */
export type PostInvoiceConfirmResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос на создание платежа
   */
  "CreateInvoiceRequest": {
    "kind": "class",
    "text": "Запрос на создание платежа",
    "fields": {
      /**
       * Идентификатор пользователя
       */
      "userId": {
        "type": "int32",
        "text": "Идентификатор пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Позиция счета
       */
      "positions": {
        "type": "Invoice.Position",
        "text": "Позиция счета",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Метод платежа
       */
      "payInterfaceType": {
        "type": "Invoice.PayInterfaceType",
        "text": "Метод платежа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Способ оплаты.
       * По умолчанию: BANK_CARD
       */
      "paywayType": {
        "type": "Invoice.PaywayType",
        "text": "Способ оплаты.\nПо умолчанию: BANK_CARD",
      },
      /**
       * Ссылка для перехода после оплаты.
       * Если не передан подставится значение по умолчанию
       */
      "returnUrl": {
        "type": "string",
        "text": "Ссылка для перехода после оплаты.\nЕсли не передан подставится значение по умолчанию",
      },
      /**
       * Номер телефона.
       * Должно быть означено поле phone_number, либо поле email
       */
      "phoneNumber": {
        "type": "string",
        "text": "Номер телефона.\nДолжно быть означено поле phone_number, либо поле email",
      },
      /**
       * Электронная почта.
       * Должно быть означено поле phone_number, либо поле email
       */
      "email": {
        "type": "string",
        "text": "Электронная почта.\nДолжно быть означено поле phone_number, либо поле email",
      },
      /**
       * Описание платежа.
       * По умолчанию подставляется \"Счёт от {DD.MM.YYYY}г.\"
       */
      "title": {
        "type": "string",
        "text": "Описание платежа.\nПо умолчанию подставляется \"Счёт от {DD.MM.YYYY}г.\"",
      },
    },
  },
  /**
   * Ответ на запрос создание платежа
   */
  "CreateInvoiceResponse": {
    "kind": "class",
    "text": "Ответ на запрос создание платежа",
    "fields": {
      /**
       * Ошибка валидации
       */
      "error": {
        "type": "CreateInvoiceResponse.Error",
        "text": "Ошибка валидации",
      },
      /**
       * Платеж
       */
      "data": {
        "type": "Invoice",
        "text": "Платеж",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "CreateInvoiceResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Должно быть означено поле phone_number, либо поле email
       */
      "missingUserContacts": {
        "type": "CreateInvoiceResponse.Error.MissingUserContacts",
        "text": "Должно быть означено поле phone_number, либо поле email",
      },
      /**
       * Ошибки внешней системы
       */
      "external": {
        "type": "Invoice.ExternalError",
        "text": "Ошибки внешней системы",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "Invoice.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
  /**
   * Должно быть означено поле phone_number, либо поле email
   */
  "CreateInvoiceResponse.Error.MissingUserContacts": {
    "kind": "class",
    "text": "Должно быть означено поле phone_number, либо поле email",
  },
  /**
   * Запрос на получение количества платежей
   */
  "GetInvoiceCountRequest": {
    "kind": "class",
    "text": "Запрос на получение количества платежей",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "InvoiceFilter",
        "text": "Фильтр",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения количества платежей
   */
  "GetInvoiceCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества платежей",
    "fields": {
      /**
       * Количество
       */
      "data": {
        "type": "int32",
        "text": "Количество",
      },
    },
  },
  /**
   * Запрос на получение списка платежей
   */
  "GetInvoiceListRequest": {
    "kind": "class",
    "text": "Запрос на получение списка платежей",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "InvoiceFilter",
        "text": "Фильтр",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "InvoicePaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка платежей
   */
  "GetInvoiceListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка платежей",
    "fields": {
      /**
       * Платежи
       */
      "data": {
        "type": "Invoice",
        "text": "Платежи",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetInvoiceListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на получение списка платежей
   */
  "GetInvoiceListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на получение списка платежей",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на получение статуса платежа
   */
  "GetInvoiceRequest": {
    "kind": "class",
    "text": "Запрос на получение статуса платежа",
    "fields": {
      /**
       * Идентификатор платежа в Ключе.
       * # Тип: Guid
       */
      "invoiceId": {
        "type": "string",
        "text": "Идентификатор платежа в Ключе.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения платежа
   */
  "GetInvoiceResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения платежа",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "GetInvoiceResponse.Error",
        "text": "Ошибка",
      },
      /**
       * Платеж
       */
      "data": {
        "type": "Invoice",
        "text": "Платеж",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "GetInvoiceResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Выставленный счёт
   */
  "Invoice": {
    "kind": "class",
    "text": "Выставленный счёт",
    "fields": {
      /**
       * Идентификатор платежа.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор платежа.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Описание платежа
       */
      "title": {
        "type": "string",
        "text": "Описание платежа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор пользователя
       */
      "userId": {
        "type": "int32",
        "text": "Идентификатор пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Статус платежа
       */
      "invoiceStatusType": {
        "type": "Invoice.InvoiceStatusType",
        "text": "Статус платежа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата создания платежа.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания платежа.\n# Тип: DateTime",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата обновления платежа.
       * # Тип: DateTime
       */
      "updatedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата обновления платежа.\n# Тип: DateTime",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Позиция счета
       */
      "positions": {
        "type": "Invoice.Position",
        "text": "Позиция счета",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Метод платежа
       */
      "payInterfaceType": {
        "type": "Invoice.PayInterfaceType",
        "text": "Метод платежа",
      },
      /**
       * Способ оплаты
       */
      "paywayType": {
        "type": "Invoice.PaywayType",
        "text": "Способ оплаты",
      },
      /**
       * Дата изменения статуса платежа.
       * # Тип: DateTime
       */
      "statusChangedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата изменения статуса платежа.\n# Тип: DateTime",
      },
      /**
       * Дата платежа.
       * # Тип: DateTime
       */
      "paidAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата платежа.\n# Тип: DateTime",
      },
      /**
       * Платежная ссылка
       */
      "payUrl": {
        "type": "string",
        "text": "Платежная ссылка",
      },
      /**
       * Маскированный номер карты при платеже
       */
      "paidByCardMasked": {
        "type": "string",
        "text": "Маскированный номер карты при платеже",
      },
      /**
       * Идентификатор платежного средства в внешней системы
       */
      "paidByCardEsppId": {
        "type": "string",
        "text": "Идентификатор платежного средства в внешней системы",
      },
      /**
       * Тип банковской карты
       */
      "cardType": {
        "type": "Invoice.CardType",
        "text": "Тип банковской карты",
      },
      /**
       * Код ошибки внешней системы
       */
      "esppReqStatus": {
        "type": "int32",
        "text": "Код ошибки внешней системы",
      },
      /**
       * Комментарий к статусу платежа из внешней системы
       */
      "esppReqUserMsg": {
        "type": "string",
        "text": "Комментарий к статусу платежа из внешней системы",
      },
      /**
       * Уникальный номер транзакции в внешней системы
       */
      "esppInvoiceId": {
        "type": "string",
        "text": "Уникальный номер транзакции в внешней системы",
      },
      /**
       * Номер телефона
       */
      "phoneNumber": {
        "type": "string",
        "text": "Номер телефона",
      },
      /**
       * Электронная почта
       */
      "email": {
        "type": "string",
        "text": "Электронная почта",
      },
    },
  },
  /**
   * Ошибки внешней системы
   */
  "Invoice.ExternalError": {
    "kind": "class",
    "text": "Ошибки внешней системы",
    "fields": {
      /**
       * Запрос к внешней системе вернул ошибку или прекращен по таймауту
       */
      "externalSystemError": {
        "type": "Invoice.ExternalError.ExternalSystemError",
        "text": "Запрос к внешней системе вернул ошибку или прекращен по таймауту",
      },
    },
  },
  /**
   * Запрос к внешней системе вернул ошибку или прекращен по таймауту
   */
  "Invoice.ExternalError.ExternalSystemError": {
    "kind": "class",
    "text": "Запрос к внешней системе вернул ошибку или прекращен по таймауту",
  },
  /**
   * Позиция счета
   */
  "Invoice.Position": {
    "kind": "class",
    "text": "Позиция счета",
    "fields": {
      /**
       * Идентификатор позиции.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор позиции.\n# Тип: Guid",
      },
      /**
       * Идентификатор платежа.
       * # Тип: Guid
       */
      "invoiceId": {
        "type": "string",
        "text": "Идентификатор платежа.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Название позиции
       */
      "title": {
        "type": "string",
        "text": "Название позиции",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Категория позиции (='subscription')
       */
      "category": {
        "type": "string",
        "text": "Категория позиции (='subscription')",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Цена в рублях.
       * Число должно быть больше 0
       */
      "amount": {
        "type": "float",
        "text": "Цена в рублях.\nЧисло должно быть больше 0",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата создания позиции платежа.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания позиции платежа.\n# Тип: DateTime",
      },
      /**
       * Дата обновления позиции платежа.
       * # Тип: DateTime
       */
      "updatedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата обновления позиции платежа.\n# Тип: DateTime",
      },
      /**
       * Идентификатор МРФ
       */
      "mrfId": {
        "type": "int32",
        "text": "Идентификатор МРФ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор РФ
       */
      "rfId": {
        "type": "int32",
        "text": "Идентификатор РФ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор экземпляра оплачиваемой подписки.
       * # Тип: Guid
       */
      "instanceId": {
        "type": "string",
        "text": "Идентификатор экземпляра оплачиваемой подписки.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор предложения оплачиваемой подписки
       */
      "offeringId": {
        "type": "int32",
        "text": "Идентификатор предложения оплачиваемой подписки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Срок окончания оплачиваемого периода
       */
      "dueDateAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Срок окончания оплачиваемого периода",
      },
      /**
       * Идентификатор получателя платежа
       */
      "svcTypeId": {
        "type": "string",
        "text": "Идентификатор получателя платежа",
      },
      /**
       * Признак скидки
       */
      "isDiscount": {
        "type": "bool",
        "text": "Признак скидки",
      },
    },
  },
  /**
   * Ошибка сохранения.
   * Эти проверки выполняются при работе с базой данных и сторонними сервисами
   */
  "Invoice.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения.\nЭти проверки выполняются при работе с базой данных и сторонними сервисами",
    "fields": {
      /**
       * У пользователя уже есть платеж со статусом PENDING
       */
      "invoiceAlreadyExists": {
        "type": "Invoice.SavingError.InvoiceAlreadyExists",
        "text": "У пользователя уже есть платеж со статусом PENDING",
      },
    },
  },
  /**
   * У пользователя уже есть платеж со статусом PENDING
   */
  "Invoice.SavingError.InvoiceAlreadyExists": {
    "kind": "class",
    "text": "У пользователя уже есть платеж со статусом PENDING",
  },
  /**
   * Фильтр инвойсов
   */
  "InvoiceFilter": {
    "kind": "class",
    "text": "Фильтр инвойсов",
    "fields": {
      /**
       * Идентификатор пользователя
       */
      "userId": {
        "type": "int32",
        "text": "Идентификатор пользователя",
      },
      /**
       * Статус платежа
       */
      "invoiceStatusType": {
        "type": "Invoice.InvoiceStatusType",
        "text": "Статус платежа",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "InvoicePaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: PAID_AT
       */
      "orderByType": {
        "type": "InvoicePaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: PAID_AT",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "InvoicePaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Запрос на подтверждение платежа
   */
  "PostInvoiceConfirmRequest": {
    "kind": "class",
    "text": "Запрос на подтверждение платежа",
    "fields": {
      /**
       * Идентификатор платежа в Ключе
       */
      "srcPayId": {
        "type": "string",
        "text": "Идентификатор платежа в Ключе",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор платежа во внешней системе
       */
      "esppPayId": {
        "type": "string",
        "text": "Идентификатор платежа во внешней системе",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Статус платежа из внешней системы
       */
      "payStatus": {
        "type": "int32",
        "text": "Статус платежа из внешней системы",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип запроса.
       * Должно иметь значение \"confirmPayment\"
       */
      "reqType": {
        "type": "string",
        "text": "Тип запроса.\nДолжно иметь значение \"confirmPayment\"",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Сумма платежа в минимальных единицах валюты
       */
      "amount": {
        "type": "float",
        "text": "Сумма платежа в минимальных единицах валюты",
      },
      /**
       * Код валюты платежа
       */
      "currency": {
        "type": "string",
        "text": "Код валюты платежа",
      },
      /**
       * Код способа оплаты
       */
      "payMethod": {
        "type": "string",
        "text": "Код способа оплаты",
      },
      /**
       * Дата регистрации платежа.
       * # Тип: DateTime
       */
      "createTimeAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата регистрации платежа.\n# Тип: DateTime",
      },
      /**
       * Комментарий или сообщение об ошибке
       */
      "reqNote": {
        "type": "string",
        "text": "Комментарий или сообщение об ошибке",
      },
      /**
       * Сообщение, отображаемое пользователю
       */
      "reqUserMsg": {
        "type": "string",
        "text": "Сообщение, отображаемое пользователю",
      },
      /**
       * Время фактической оплаты. Время фактической оплаты на стороне Процессинга. Возвращается, если оплата состоялась
       */
      "payTimeAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Время фактической оплаты. Время фактической оплаты на стороне Процессинга. Возвращается, если оплата состоялась",
      },
      /**
       * Время фактической отмены оплаты.
       * Время фактической отмены оплаты на стороне Процессинга.
       * Возвращается, если отмена оплаты состоялась
       */
      "abandonTimeAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Время фактической отмены оплаты.\nВремя фактической отмены оплаты на стороне Процессинга.\nВозвращается, если отмена оплаты состоялась",
      },
      /**
       * Структура с информацией о карте плательщика.
       * Передаётся только при успешном платеже и если указаны способы оплаты payMethod = StoredBankCard либо BankCard
       */
      "card": {
        "type": "PostInvoiceConfirmRequest.Card",
        "text": "Структура с информацией о карте плательщика.\nПередаётся только при успешном платеже и если указаны способы оплаты payMethod = StoredBankCard либо BankCard",
      },
    },
  },
  /**
   * Структура с информацией о карте плательщика
   */
  "PostInvoiceConfirmRequest.Card": {
    "kind": "class",
    "text": "Структура с информацией о карте плательщика",
    "fields": {
      /**
       * Идентификатор платежного средства во внешней системы.
       * Возвращается в случае успешной привязки БК к УЗ
       */
      "esppCardId": {
        "type": "int32",
        "text": "Идентификатор платежного средства во внешней системы.\nВозвращается в случае успешной привязки БК к УЗ",
      },
      /**
       * Номер платежного средства.
       * Маскированный номер карты. Например: 123456******7890
       */
      "cardNum": {
        "type": "string",
        "text": "Номер платежного средства.\nМаскированный номер карты. Например: 123456******7890",
      },
      /**
       * Тип банковской карты
       */
      "cardKind": {
        "type": "string",
        "text": "Тип банковской карты",
      },
      /**
       * Банк-эмитент.
       * Наименование банка-эмитента. Процессинг может вернуть значение \"НЕ ЗАДАВАЛСЯ\".
       * В этом случае рекомендуется не отображать эту информацию для пользователя
       */
      "bankName": {
        "type": "string",
        "text": "Банк-эмитент.\nНаименование банка-эмитента. Процессинг может вернуть значение \"НЕ ЗАДАВАЛСЯ\".\nВ этом случае рекомендуется не отображать эту информацию для пользователя",
      },
    },
  },
  /**
   * Ответ на запрос подтверждения платежа
   */
  "PostInvoiceConfirmResponse": {
    "kind": "class",
    "text": "Ответ на запрос подтверждения платежа",
  },
  /**
   * Справочник банковских карт
   */
  "Invoice.CardType": {
    "kind": "enum",
    "text": "Справочник банковских карт",
    "values": {
      /**
       * Значение не указано
       */
      "CARD_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Карта VISA
       */
      "VISA": {
        "i": 1,
        "text": "Карта VISA",
      },
      /**
       * Карта EuroCard/MasterCard
       */
      "EC_MC": {
        "i": 2,
        "text": "Карта EuroCard/MasterCard",
      },
      /**
       * Карта DinersClub
       */
      "DCL": {
        "i": 3,
        "text": "Карта DinersClub",
      },
      /**
       * Карта JCB
       */
      "JCB": {
        "i": 4,
        "text": "Карта JCB",
      },
      /**
       * Карта American Express
       */
      "AMEX": {
        "i": 5,
        "text": "Карта American Express",
      },
      /**
       * Платежная система \"Мир\"
       */
      "MIR": {
        "i": 6,
        "text": "Платежная система \"Мир\"",
      },
    },
  },
  /**
   * Справочник типов статусов оплаты счёта
   */
  "Invoice.InvoiceStatusType": {
    "kind": "enum",
    "text": "Справочник типов статусов оплаты счёта",
    "values": {
      /**
       * Значение не указано
       */
      "INVOICE_STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Создан, ожидает подтверждения
       */
      "PLANNED": {
        "i": 1,
        "text": "Создан, ожидает подтверждения",
      },
      /**
       * Ожидает оплаты
       */
      "PENDING": {
        "i": 2,
        "text": "Ожидает оплаты",
      },
      /**
       * Ошибка оплаты
       */
      "ERROR": {
        "i": 3,
        "text": "Ошибка оплаты",
      },
      /**
       * Оплачен
       */
      "PAID": {
        "i": 4,
        "text": "Оплачен",
      },
      /**
       * Отменен
       */
      "CANCELLED": {
        "i": 5,
        "text": "Отменен",
      },
    },
  },
  /**
   * Справочник методов платежа
   */
  "Invoice.PayInterfaceType": {
    "kind": "enum",
    "text": "Справочник методов платежа",
    "values": {
      /**
       * Значение не указано
       */
      "PAY_INTERFACE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Оплата через интерфейс предпроцессинга
       */
      "GUI": {
        "i": 1,
        "text": "Оплата через интерфейс предпроцессинга",
      },
      /**
       * Оплата с использованием ранее созданного способа платежа, настроенного по умолчанию
       */
      "M2M": {
        "i": 2,
        "text": "Оплата с использованием ранее созданного способа платежа, настроенного по умолчанию",
      },
    },
  },
  /**
   * Справочник типов платежных средств
   */
  "Invoice.PaywayType": {
    "kind": "enum",
    "text": "Справочник типов платежных средств",
    "values": {
      /**
       * Значение не указано
       */
      "PAYWAY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Банковская карта
       */
      "BANK_CARD": {
        "i": 1,
        "text": "Банковская карта",
      },
      /**
       * Сервис быстрых платежей
       */
      "SBP": {
        "i": 2,
        "text": "Сервис быстрых платежей",
      },
      /**
       * Связка Сбербанка
       */
      "SBER_PAY": {
        "i": 3,
        "text": "Связка Сбербанка",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "InvoicePaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "InvoicePaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По дате оплаты
       */
      "PAID_AT": {
        "i": 2,
        "text": "По дате оплаты",
      },
      /**
       * По дате создания
       */
      "CREATED_AT": {
        "i": 3,
        "text": "По дате создания",
      },
    },
  },
}